import styled, {css} from "styled-components";
import {fontFamily, palette, PaletteColor} from "../styles";
import {baseSizes, baseWeights, boldFontTransformAdjustment, Size, Weight} from "../styleSizes";

export const InlineLinkDisabledStyled = styled.span`
  font-family: ${fontFamily};
  display: inline-flex;
  align-items: center;
  text-decoration: underline;
  color: ${palette.neutral700};
  cursor: default;

  &:hover {
    text-decoration: none;
  }

  &:active {
    color: ${palette.neutral700};
  }

  &:visited {
    color: ${palette.neutral700};
  }
`;

export const InlineLinkStyled = styled.a`
    font-family: ${fontFamily};
    display: inline-flex;
    align-items: center;
    color: #262626;
    text-decoration: underline;
    cursor: pointer;

    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    touch-action: manipulation;
    user-select: none;

    &:hover, &:active {
        font-weight: 400;
        text-shadow: 0.02em 0 0 currentColor;
    }

    &:active {
        color: ${palette.blue800};
        transform: none;
    }

    &:visited {
        color: ${palette.blue800};
    }

    &:focus {
        outline: 2px solid ${palette.blue800};
    }
`;

type BodyProps = {
  $size?: Size;
  $weight?: Weight;
  $color?: PaletteColor;
  $overflowWrap?: string;
  $textAlign?: string;
};

export const BodyStyled = styled.span<BodyProps>`
  font-family: ${fontFamily};
  ${props =>
         props.$size === "xx-small" &&
          css`
              font-family: Arial, sans-serif;
        `}
  ${props =>
          props.$color &&
          css`
            color: ${props.$color};
          `};
  ${props =>
          props.$overflowWrap &&
          css`
            overflow-wrap: ${props.$overflowWrap};
          `};
  ${props =>
          props.$textAlign &&
          css`
            text-align: ${props.$textAlign};
          `};
  ${baseSizes};
  ${baseWeights};
  ${boldFontTransformAdjustment};
`;

export const InfoIconTooltipStyled = styled.div`
  display: inline-block;
  position: relative;
`;

type BaseSizesProps = {
  $size?: Size;
};

export const BodyTooltipWrapperStyled = styled.div<BaseSizesProps>`
  display: inline-block;
  
  > div {
    display: block !important;
    top: -3px;
  }

  ${props =>
          props.$size === "xx-small" &&
          css` 
            svg {
              height: 20px;
            }
          `}
  ${props =>
          props.$size === "x-small" &&
          css`
            svg {
              height: 22px;
            }
          `}
  ${props =>
          props.$size === "small" &&
          css`
            svg {
              height: 24px;
            }
          `}
  ${props =>
          props.$size === "medium" &&
          css`
            svg {
              height: 26px;
            }
          `}
  ${props =>
          props.$size === "large" &&
          css`
            svg {
              height: 34px;
            }
          `}
  ${props =>
          props.$size === "x-large" &&
          css`
            svg {
              height: 40px;
            }
          `}
`;


